import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import stylesheet from './ButtonLink.less';

/**
 * ButtonLinks are visually identical to the Button component, but wrap `a` tags instead of `button` tags.
 *
 * @deprecated Use the ButtonOrLink component from mc/wink instead.
 *
 */
const ButtonLink = React.forwardRef(
  (
    {
      children,
      className,
      clearMargin,
      href,
      onClick,
      rel = 'noopener',
      type,
      ...rest
    },
    ref,
  ) => {
    const classList = cx(
      stylesheet.container,
      {
        [stylesheet.important]: type === 'important',
        [stylesheet.primary]: type === 'primary',
        [stylesheet.secondary]: type === 'secondary',
        [stylesheet.tertiary]: type === 'tertiary',
        [stylesheet.clearMargin]: clearMargin === true,
      },
      className,
    );

    return (
      <a
        href={href}
        className={classList}
        onClick={onClick}
        rel={rel}
        ref={ref}
        {...rest}
      >
        {children}
      </a>
    );
  },
);

ButtonLink.propTypes = {
  /** The content inside the button */
  children: PropTypes.node.isRequired,
  /** A custom class name that is appended to the button classes. */
  className: PropTypes.string,
  /** Sets the default button margins to zero */
  clearMargin: PropTypes.bool,
  /** href attribute for the link */
  href: PropTypes.string.isRequired,
  /** Mouse click event. Please use href for any navigation and only use onClick for side effects such as analytics. */
  onClick: PropTypes.func,
  /** rel attribute for the link */
  rel: PropTypes.string,
  /** The different variants of a ButtonLink */
  type: PropTypes.oneOf(['important', 'primary', 'secondary', 'tertiary'])
    .isRequired,
};

export default ButtonLink;
